module.exports = __webpack_public_path__ + "img/team-classic-3-370x397.78b193f8.jpg";